import template from './menuOptionsFamily.html';
import controller from './menuOptionsFamily.controller';
import './menuOptionsFamily.scss';

let menuOptionsFamilyComponent = {
  restrict: 'E',
  bindings: {
    familyDetails: '<',
    onSelectOptionFamily: '&',
    optionFamilySelected: '<',
    simulationWitness: '<',
  },
  template,
  controller,
};

export default menuOptionsFamilyComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuOptionsFamily/menuOptionsFamily.component.js